<template>
  <div>
    <div class="details-title">
      <van-nav-bar title="课程详情" left-arrow @click-left="goBlack" @click-right="show2 = true">
        <template #right>
          <img class="icon" :src="icon" alt />
        </template>
      </van-nav-bar>
    </div>
    <div class="details-video">
      <video-player
        v-if="videoData!=null"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
    <div class="details-conter">
      <div class="d-c-title">
        <div v-if="bianji==1">
          <span v-if="titlevalue!=''">{{titlevalue}}</span>
          <span class="d-c-title-k" v-else>暂无课程名称,请编辑</span>
        </div>
        <div class="d-c-title-2" v-else>
          <van-field maxlength="30" v-model="changeTitlevalue" placeholder="请输入课程名称" />
          <span class>{{changeTitlevalue.length}}/30</span>
        </div>
      </div>
      <div class="d-c-information">
        <div class="if-title">基本信息</div>
        <ul class="if-conter">
          <li>
            <span class="if-c-1">授课老师</span>
            <span class="if-c-2">{{teacherName}}</span>
          </li>
          <li>
            <span class="if-c-1">课程来源</span>
            <span class="if-c-2">{{schoolName}}</span>

          </li>
          <li>
            <span class="if-c-1">所授科目</span>
            <span class="if-c-2" v-if="bianji==1">{{subjectName}}</span>
            <van-cell v-else is-link :title="subjectNameTitle" @click="kemushow = true" />
          </li>
          <li>
            <span class="if-c-1">所授年级</span>
            <span class="if-c-2" v-if="bianji==1">{{gradeName}}</span>
            <van-cell v-else is-link :title="gradeNameList" @click="nianjshow = true" />
          </li>
        </ul>
      </div>
<!--      <div class="d-c-open">-->
<!--        <div class="op-title">公开级别</div>-->
<!--        <div class="op-conter">-->
<!--          <span>公开级别</span>-->
<!--          <span class="if-c-2" v-if="bianji==1">{{gkName}}</span>-->
<!--          <van-cell v-if="bianji==2" is-link :title="gkNameList" @click="gkshow = true" />-->
<!--        </div>-->
<!--      </div>-->
      <div class="d-c-introduce">
        <div class="it-title">课程介绍</div>
        <div class="it-conter" v-if="bianji==1">{{ courseInfo }}</div>
        <van-field v-else maxlength="30" v-model="remarkValue" placeholder="请输入课程介绍" />

<!--        <div class="it-conter2">{{courseInfo}}</div>-->
      </div>
    </div>
    <div class="details-btns" v-if="bianji==1">
      <van-button  type="primary" class="details-button edit" @click="edit">编辑</van-button>
      <van-button  type="primary" class="details-button open" v-if="isStart==='1'" @click="release">发布</van-button>
    </div>
    <div class="btnDiv" v-else>
      <van-button type="default" class="btn-bc" @click="editBc(false)">取消</van-button>
      <van-button type="primary" class="btn-fb" @click="editBc(true)">保存</van-button>
    </div>
    <!-- 所受科目的弹出 -->
    <van-action-sheet v-model="kemushow" :actions="kemuactions" @select="onSelectkm" />
    <!-- 所受年级的弹出 -->
    <van-action-sheet v-model="nianjshow" :actions="nianjactions" @select="onSelectnj" />
    <!-- 公开级别的弹出 -->
    <van-action-sheet v-model="gkshow" :actions="gkactions" @select="onSelectgk" />
    <!-- 右上角三个点的弹出 -->
<!--    <van-action-sheet v-model="show2" title="标题" cancel-text="取消">-->
<!--      <div class="moreContent">-->
<!--        <div class="moreContent-1" v-for="n in more" :key="n.id" @click="morebianj(n.name)">-->
<!--          <img :src="n.img" alt />-->
<!--          <div>{{n.name}}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-action-sheet>-->
    <van-dialog
        v-model:show="show2"
        title="删除确认"
        show-confirm-button
        show-cancel-button
        @confirm="deleteVideo"
        @close="show2=false"
    >
    </van-dialog>
    <van-dialog
        v-model:show="show3"
        title="发布提示"
        show-confirm-button
        show-cancel-button
        @confirm="toggleRelease"
        @close="show3=false"
    >
    </van-dialog>
    <van-overlay :show="maskShow" @click="maskShow = false">
      <div class="wrapper" @click.stop>
        <div class="block" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  getVideo,
  getDownList,
  setEdit,
  updateUserInfo,
  deleteCourse,
} from "@/api/details/index.js";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
  },
  data() {
    return {
      maskShow: false, //遮罩
      videoId: this.$route.query.gameId,
      videoData: null,
      teacherName: "主讲老师",
      courseInfo:
        "若未产生材料配送费用，则不扣除费用，若教材已寄出，则按实际情况收费",
      schoolName: "高田中学",
      subjectName: "",
      gradeName: "",
      gkName: "",
      remarkValue:'',
      icon: require("@/assect/delete@2x.png"),
      more: [],
      bianji: 1,
      titlevalue: "",
      changeTitlevalue: "",
      show2: false,
	    show3: false,
      //科目选择列表是否弹出及数据
      kemushow: false,
      kemuactions: [{ name: "暂无选项" }],
      kemId: "",
      kemIdSubmit: "",
      //年级选择列表是否弹出及数据
      nianjshow: false,
      nianjactions: [{ name: "暂无选项" }],
      nianjId: "",
      nianjIdSubmit: "",
      //是否公开选择列表是否弹出及数据
      gkshow: false,
      gkactions: [{ name: "暂无选项" }],
      gkId: "",
      gkIdSubmit: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      bianjiList: [], //编辑下拉数据
      courseNameTitle: "",
      gradeNameList: "请选择年级",
      gkNameList: "",
      subjectNameTitle: "请选择科目",
      isStart:'',
    };
  },
  mounted() {
	  if(!this.isMOBILE()){
		  this.$router.push({
			  path:'/subjectEdit'
		  })
	  }
	  this.getVideo();
  },
	methods: {
    //获取详情
    getVideo() {
      this.maskShow = true;
      getVideo({ courseId: this.videoId })
        .then((res) => {
          if (res.code == 0) {
            // console.log(res.courseInfo.notesCourse);
            // if (res.courseInfo.notesCourse.isStart == 0) {
            //   this.more = [
            //     { img: require("@/assect/delete.png"), name: "删除" },
            //     // { img: require("@/assect/edit.png"), name: "编辑" },
            //
            //     { img: require("@/assect/down2.png"), name: "下架" },
            //   ];
            // } else {
            //   this.more = [
            //     { img: require("@/assect/delete.png"), name: "删除" },
            //     // { img: require("@/assect/edit.png"), name: "编辑" },
            //     { img: require("@/assect/up.png"), name: "上架" },
            //   ];
            // }

            this.titlevalue = res.courseInfo.notesCourse.courseName;

            this.changeTitlevalue = this.titlevalue;
            this.videoData = res.courseInfo.notesCourse;
            this.playerOptions.poster = res.courseInfo.notesCourse.coverImage;
            this.playerOptions.sources[0].src =
              res.courseInfo.notesCourse.courseAddress;
            this.teacherName = this.videoData.teacherName;
            this.courseInfo = this.videoData.courseInfo;
            this.remarkValue = this.courseInfo
            this.schoolName = this.videoData.schoolName;
            this.subjectName = this.videoData.subjectName;
            this.gradeName = this.videoData.gradeName;
            this.isStart = res.courseInfo.notesCourse.isStart
            if (res.courseInfo.notesCourse.isOpen == 0) {
              this.gkName = "公开";
            } else {
              this.gkName = "私密";
            }
            this.gkNameList = this.gkName;
            if (this.subjectName != "" && this.subjectName != null) {
              this.subjectNameTitle = this.subjectName;
            }
            if (this.gradeName != "" && this.gradeName != null) {
              this.gradeNameList = this.gradeName;
            }

            //保存各种ID
            //是否公开
            this.gkId = res.courseInfo.notesCourse.isOpen;
            this.gkIdSubmit = this.gkId;
            //年级id
            this.nianjId = res.courseInfo.notesCourse.gradeId;
            this.nianjIdSubmit = this.nianjId;
            //课程ID
            this.kemId = res.courseInfo.notesCourse.subjectId;
            this.kemIdSubmit = this.kemId;
            this.getDownList(res.courseInfo.notesCourse.schoolId);
          } else {
            this.$toast(res.msg);
          }
          this.maskShow = false;
        })
        .catch((res) => {
          this.maskShow = false;
        });
    },
    //获取下拉列表参数
    getDownList(id) {
      const data = { schoolId: id };
      getDownList(data).then((res) => {
        if (res.code == 0) {
          const newData = [];
          const newData2 = [];
          const newData3 = [];

          this.bianjiList = res;
          for (let i = 0; i < res.grade.length; i++) {
            const listData = { name: "" };
            listData.name = res.grade[i].gradeName;
            newData.push(listData);
          }

          for (let i = 0; i < res.isOpen.length; i++) {
            const listData2 = { name: "" };
            listData2.name = res.isOpen[i].dict_label;
            newData2.push(listData2);
          }

          for (let i = 0; i < res.subject.length; i++) {
            const listData3 = { name: "" };
            listData3.name = res.subject[i].subjectName;
            newData3.push(listData3);
          }

          this.nianjactions = newData;
          this.gkactions = newData2;
          this.kemuactions = newData3;
        }
      });
    },

    goBlack() {
      this.$router.go(-1);
    },
    edit() {
      this.bianji = 2;
    },
    //取消保存按钮
    editBc(judge) {
      if (judge) {
        this.bianji = 1;
        this.tjEdit();
      } else {
        this.changeTitlevalue = this.titlevalue;
        this.gkNameList = this.gkName;
        this.gkIdSubmit = this.gkId;
        this.courseNameTitle = this.courseName;
        this.kemIdSubmit = this.kemId;
        this.gradeNameList = this.gradeName;
        this.nianjIdSubmit = this.nianjId;
        this.remarkValue = this.courseInfo
        this.bianji = 1;
      }
    },
    //提交数据
    tjEdit() {
      const data = {
        courseName: this.changeTitlevalue,
        isOpen: this.gkIdSubmit,
        gradeId: this.nianjIdSubmit,
        subjectId: this.kemIdSubmit,
        courseId: this.videoId,
	      courseInfo: this.remarkValue
      };
      setEdit(data).then((res) => {
        if (res.code == 0) {
	        Toast.success('保存成功！');
          this.getVideo();
        }
      });
    },
	  release() {
    	this.show3 = true
    },
    toggleRelease() {
    	const data = {
		    courseId: this.videoId,
		    isOpen: this.gkIdSubmit,
        isStart:'0'
      }
	    setEdit(data).then((res) => {
		    if (res.code == 0) {
			    this.getVideo();
		    }
	    });
    },

    //下拉列表改变参数
    onSelectkm(item) {
      this.subjectNameTitle = item.name;
      const km = this.bianjiList.subject;
      for (let i = 0; i < km.length; i++) {
        if (km[i].subjectName == item.name) {
          this.kemIdSubmit = km[i].subjectId;
        }
      }
      this.kemushow = false;
    },
    onSelectnj(item) {
      this.gradeNameList = item.name;
      const nj = this.bianjiList.grade;
      for (let i = 0; i < nj.length; i++) {
        if (nj[i].gradeName == item.name) {
          this.nianjIdSubmit = nj[i].gradeId;
        }
      }
      this.nianjshow = false;
    },
    onSelectgk(item) {
      this.gkNameList = item.name;
      const gk = this.bianjiList.isOpen;
      for (let i = 0; i < gk.length; i++) {
        if (gk[i].dict_label == item.name) {
          this.gkIdSubmit = gk[i].dict_value;
        }
      }
      this.gkshow = false;
    },

    morebianj(name) {
      if (name == "下架") {
        this.updateUserInfo(1);
      } else if (name == "上架") {
        this.updateUserInfo(0);
      } else if (name == "删除") {
        this.deleteCourse();
      }
    },
	  deleteVideo() {
		  this.deleteCourse();
    },
    //上下架
    updateUserInfo(isStart) {
      Dialog.confirm({
        title: "课件上下架",
        message: "请确认操作",
      })
        .then(() => {
          if (this.changeTitlevalue == "") {
            this.$toast("请确认课程名称是否填写");
            this.show2 = false;
            return;
          } else if (
            this.subjectNameTitle == "" ||
            this.subjectNameTitle == "请选择科目"
          ) {
            this.$toast("请确认所授科目是否填写");
            this.show2 = false;
          } else if (
            this.gradeNameList == "" ||
            this.gradeNameList == "请选择年级"
          ) {
            this.$toast("请确认所授年级是否填写");
            this.show2 = false;
          } else {
            const data = { isStart: isStart, courseId: this.videoId };
            updateUserInfo(data)
              .then((res) => {
                if (res.code == 0) {
                  this.$notify({
                    message: "操作成功",
                    type: "success",
                    duration: 1000,
                  });
                  this.$router.go(-1);
                } else {
                  this.$notify({
                    message: "操作失败，请重试",
                    type: "danger",
                    duration: 1000,
                  });
                  this.show2 = false;
                }
              })
              .catch(function (error) {
                this.$notify({
                  message: "操作失败，请重试",
                  type: "danger",
                  duration: 1000,
                });
              });
          }
        })
        .catch(() => {
          this.$toast("已取消操作");
          this.show2 = false;
        });
    },
    //删除课程
    deleteCourse() {
      Dialog.confirm({
        title: "删除课件",
        message: "请确认是否删除",
      })
        .then(() => {
          const data = { courseId: this.videoId };
          deleteCourse(data)
            .then((res) => {
              if (res.code == 0) {
                this.$notify({
                  message: "操作成功",
                  type: "success",
                  duration: 1000,
                });
                this.$router.go(-1);
              } else {
                this.$notify({
                  message: "操作失败，请重试",
                  type: "danger",
                  duration: 1000,
                });
                this.show2 = false;
              }
            })
            .catch(function (error) {
              this.$notify({
                message: "操作失败，请重试",
                type: "danger",
                duration: 1000,
              });
            });
        })
        .catch(() => {
          this.$toast("已取消删除");
          this.show2 = false;
        });
    },
	  isMOBILE () {
		  let flag = navigator.userAgent.match(
			  /(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
		  )
		  return flag
	  }
  },
};
</script>

<style lang="less" scoped>
.details-title {
  height: 12vw;
}
.details-video {
  height: 56vw;
  background-color: #999;
}
.d-c-title-2 {
  display: flex;

  color: rgb(211, 216, 220);
  align-items: center;
  .van-cell {
    padding: 0;
    font-size: 4.5vw;
  }
  span {
    font-size: 2vw;
  }
}

.details-conter {
  /*padding: 0 4.5vw;*/
  &>div{
    padding: 0 4vw;
  }
  .d-c-title {
    margin-top: 3.7vw;
    color: #24292e;
    font-size: 4.5vw;
    font-weight: 600;
    padding-bottom: 5.2vw;
    border-bottom: 1.45vw solid #f6fafd;
    .d-c-title-k{
          color: #a1a8af;
    }
  }
  .d-c-information {
    .if-title {
      margin-top: 3.8vw;
      color: #24292e;
      font-size: 4.5vw;
      font-weight: 600;
    }

    .if-conter {
      li {
        // width: 100vw;
        margin-top: 2.5vw;
        margin-left: 7vw;
        font-size: 3.9vw;
        display: flex;
        .if-c-1 {
          color: #6d7277;
        }
        .if-c-2 {
          margin-left: 7.3vw;
          color: #a1a8af;
        }


        .van-cell {
          margin-left: 7.3vw;
          font-size: 3.9vw;
          color: #a1a8af;
          padding: 0;
          width: 70%;
          &.van-field{
            border: 1px solid #d3d3d3;
          }
        }
      }
    }
    padding-bottom: 5.2vw;
    border-bottom: 1.45vw solid #f6fafd;
  }
  .d-c-open {
    .op-title {
      margin-top: 3.8vw;
      color: #24292e;
      font-size: 4.5vw;
      font-weight: 600;
    }
    .op-conter {
      margin-top: 4.5vw;
      margin-left: 7vw;
      font-size: 3.9vw;
      color: #6d7277;
      display: flex;
      align-items: center;
      .if-c-2 {
        margin-left: 7.3vw;
        color: #a1a8af;
      }
      .van-cell {
        margin-left: 7.3vw;
        font-size: 3.9vw;
        color: #a1a8af;
        padding: 0;
        width: 70%;
      }
    }
    padding-bottom: 5.2vw;
    border-bottom: 1.45vw solid #f6fafd;
  }
  .d-c-introduce {
    .it-title {
      margin-top: 3.8vw;
      color: #24292e;
      font-size: 4.5vw;
      font-weight: 600;
    }
    .it-conter {
      margin-top: 4.5vw;
      margin-left: 7vw;
      font-size: 3.9vw;
      color: #6d7277;
    }
    .it-conter2 {
      margin-top: 4.5vw;
      margin-left: 7vw;
      font-size: 3.8vw;
      color: #a1a8af;
    }
    padding-bottom: 5.2vw;
    border-bottom: 1.45vw solid #f6fafd;
  }
}
.details-btns{
  display: flex;
  justify-content: space-between;
  margin: 2vw 1.5vw;
}
.details-button {
  width: 45vw;
  border-radius: 1.5vw;
  font-size: 5vw;

  &.edit{
    background-color: #fff;
    color: #25c991;
    border: 1px solid #25c991;
  }
  &.open{
    background-color: #25c991;
  }
}
.btnDiv {
  display: flex;
  justify-content: space-around;
  font-size: 5.1vw;
  margin-top: 2vw;
  .btn-bc {
    width: 42.5vw;
    font-size: 5.1vw;
    font-weight: 500;
    color: #25c991;
    border: 1px solid #25c991;
    border-radius: 1vw;
  }
  .btn-fb {
    width: 42.5vw;
    font-size: 5.1vw;
    font-weight: 500;
    background-color: #25c991;
    color: white;
    border-radius: 1vw;
  }
}
.moreContent {
  margin: 5.5vw 0;
  display: flex;
  //   justify-content: space-around;
  .moreContent-1 {
    width: 15vw;
    height: 18vw;
    text-align: center;
    margin-right: 5vw;
    // background-color: pink;
    img {
      width: 11vw;
      height: 11vw;
    }
    div {
      margin-top: 3vw;

      font-size: 3.7vw;
      color: #6d7277;
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
  background: url("~@/assect/loading.gif");
}
</style>

<style lang="less" >
.details-title {
  .van-nav-bar {
    background-color: #25c991 !important;
    .van-nav-bar__right {
      .icon {
        width: 6vw;
      }
    }
  }
}
</style>